<div class="scroll-content">
  <div class="upsellDownsell">
    <div class="upDownPage">
      <ng-container *ngFor="let content of pageContents; let i = index; trackBy: trackByIndex">
        <ng-container [ngSwitch]="content.type">
          <ng-container *ngSwitchCase="'component'">
            <ng-container [ngSwitch]="content.componentName">
              <ng-container *ngSwitchCase="'upsell-header'">
                <upsell-header [dynamicPhoneNumber]="dynamicPhoneNumber" class="{{ content.class }}"></upsell-header>
              </ng-container>
              <ng-container *ngSwitchCase="'progress-bar'">
                <progress-bar *ngIf="totalProductsSummary" [total]="minForFreeShipping"
                [current]="totalProductsSummary" [title]="progressBarTitle" [logo]="progressBarLogo"
                [subTitle]="progressBarSubTitle" [customText]="progressBarCustomText" class="{{ content.class }}"></progress-bar>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-sticky-bar'">
                <upsell-sticky-bar [brand]="productBrand" [name]=" productName" [image]="productImage"
                [ngClass]="content.class" [quantity]="productQuantity" [total]="productYourPrice"
                [productUnitType]="productUnitType" [addToCartText]="stickyBarAddToCartText"
                (itemAdded)="nextPage($event)" [showButton]="showButton" [buttonYesText]="garantee_01_buttonYesText"
                [showbuttonYesText]="garantee_01_showbuttonYesText" [buttonNoText]="garantee_01_buttonNoText"
                [showbuttonNoText]="garantee_01_showbuttonNoText" [description]="garantee_01_description"
                [showDescription]="garantee_01_showDescription"
                [upsellCtaTextButtonsClass]="garantee_01_upsellCtaTextButtonsClass"
                [showImage]="garantee_01_showImage" class="{{ content.class }}"></upsell-sticky-bar>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-sticky-bar-v2'">
                <upsell-sticky-bar-v2 [productBrand]="productBrand" [productName]="productName" [productImage]="productImage" [productYourPrice]="productYourPrice"
                  [ngClass]="content.class" [productQuantity]="productQuantity" [total]="productYourPrice"
                  [productUnitType]="productUnitType" [addToCartText]="stickyBarAddToCartText"
                  (itemAdded)="nextPage($event)" (eventEmitter)="nextPage($event)" [currency]="currency" class="{{ content.class }}">
                </upsell-sticky-bar-v2>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-steps'">
                <upsell-steps *ngIf="steps_show" [steps]="steps_items" [stepLabel]="step_label"
                [showNumbers]="showNumbers" [newStepsStyle]="content.options?.newStepsStyle || false" class="{{ content.class }}"></upsell-steps>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-wait'">
                <upsell-wait *ngIf="wait_show" [isFull]="wait_isFull" [title]="wait_title"
                [description]="wait_description" [iconText]="wait_text" [iconWait]="iconImgWait" class="{{ content.class }}">
                </upsell-wait>
              </ng-container>
              <ng-container *ngSwitchCase="'video-player'">
                <video-player 
                  [videoID]="videoID" 
                  [videoClass]="videoClass"
                  [videoThumbnail]="videoThumbnail"
                  [videoPlayType]="videoPlayType"
                  class="{{ content.class }}"
                >
                </video-player>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-section'">
                <upsell-section [ngClass]="content.class" [content]="content.options"></upsell-section>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-why'">
                <upsell-why class="{{ content.class }}" [content]="content.options"></upsell-why>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-product-box'">
                <upsell-product-box *ngIf="product_box_show" [currency]="currency"
                [braintreeCurrencyConversion]="braintreeCurrencyConversion" [currencySymbol]="currencySymbol"
                [officialCurrency]="officialCurrency" [title]="product_box_title"
                [showTitle]="product_box_showTitle" [image]="productImage" [imageAlt]="productTitle"
                [subTitle]="product_box_subTitle" [regularPrice]="productRegularPrice"
                [instantSavings]="productInstantSavings" [yourPriceText]="product_box_yourPriceText"
                [instantSavingsText]="product_box_instantSavingsText" [regularText]="product_box_regularText"
                [yourPrice]="productYourPrice" [auxImg]="auxImg" [auxImgAlt]="auxImgAlt" class="{{ content.class }}">
                </upsell-product-box>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-product-box-full'">
                <upsell-product-box-full [currency]="currency"
                [braintreeCurrencyConversion]="braintreeCurrencyConversion" [currencySymbol]="currencySymbol"
                [officialCurrency]="officialCurrency" [title]="product_box_full_title" [image]="productImage"
                [imageAlt]="productTitle" [additionalImage]="product_box_full_additionalImage"
                [yourPriceText]="product_box_yourPriceText" [instantSavingsText]="product_box_instantSavingsText"
                [regularText]="product_box_regularText" [regularPrice]="productRegularPrice"
                [instantSavings]="productInstantSavings" [yourPrice]="productYourPrice" class="{{ content.class }}"></upsell-product-box-full>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-wait-rectangular'">
                <upsell-wait-rectangular [isFull]="wait_isFull" [title]="wait_title" [description]="wait_description"
                [iconText]="wait_text" [iconWait]="iconImgWait" class="{{ content.class }}"></upsell-wait-rectangular>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-guarantee'">
                <upsell-guarantee *ngIf="garantee_01_show" [buttonYesText]="garantee_01_buttonYesText"
                [showbuttonYesText]="garantee_01_showbuttonYesText" [buttonNoText]="garantee_01_buttonNoText"
                [showbuttonNoText]="garantee_01_showbuttonNoText" [description]="garantee_01_description"
                [showDescription]="garantee_01_showDescription" [image]="garantee_01_image"
                [imageAlt]="garantee_01_imageAlt" [showImage]="garantee_01_showImage"
                [upsellCtaTextButtonsClass]="garantee_01_upsellCtaTextButtonsClass" [customHtmlContent]="garantee_01_customHtmlContent"
                (eventEmitter)="nextPage($event)" class="{{ content.class }}"></upsell-guarantee>
              </ng-container>
              <ng-container *ngSwitchCase="'brand-reviews'">
                <brand-reviews [reviewsTitle]="content.options?.reviewsTitle || reviewsTitle" 
                              [reviews]="content.options?.reviews"
                              [perReviewAddOn]="content.options?.perReviewAddOn || perReviewAddOn" class="{{ content.class }}"></brand-reviews>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-modal'">
                <upsell-modal
                  [show]="showModal"
                  [title]="content.options.title"
                  [message]="content.options.message"
                  [buttonText]="content.options.buttonText"
                  (close)="closeModal()"
                  (cta)="onModalCTA()"
                  [upsellModalInputs]="{
                    title: content.options.title,
                    message: content.options.message,
                    buttonText: content.options.buttonText,
                    html: content.options.html
                  }"
                ></upsell-modal>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-offer-spinner'">
                <upsell-offer-spinner-v2
                  [title]="optionsSpinner?.title"
                  [description]="optionsSpinner?.description"
                  [spinButtonText]="optionsSpinner?.spinButtonText"
                  [spinnedTitle]="optionsSpinner?.spinnedTitle"
                  [spinnedDescription]="optionsSpinner?.spinnedDescription"
                  [spinnedButtonText]="optionsSpinner?.spinnedButtonText"
                  [declineButtonText]="optionsSpinner?.declineButtonText"
                  [wheelCenterImage]="optionsSpinner?.wheelCenterImage"
                  [wheelOptions]="optionsSpinner?.wheelOptions"
                  [pointerAngle]="optionsSpinner?.pointerAngle"
                  [closeAfterSpinTime]="optionsSpinner?.closeAfterSpinTime"
                ></upsell-offer-spinner-v2>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-footer'">
                <upsell-footer class="{{ content.class }}" [links]="footerLinks" [text]="footerText" [brand]="productBrand"
                [address]="footerAddress"></upsell-footer>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-disclaimer'">
                <upsell-disclaimer [disclaimerText]="disclaimerText"></upsell-disclaimer>
              </ng-container>
              <ng-container *ngSwitchCase="'upsell-video'">
                <upsell-video
                  [videoID]="content?.options.videoID"
                  [videoPlayerType]="content?.options.videoPlayerType"
                  [accountID]="content?.options.accountID"
                ></upsell-video>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'html'">
            <div class="{{ content.name }}" [innerHTML]="content.html">
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>